import { clarityOneLoginUrlWithRedirect } from "@shared/clarityOneAuthRedirect";

export const CLARITY_ONE_SESSION_TIMEOUT_MS = 12_000;

export type ClarityOneMeQueryState = {
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  isSuccess: boolean;
  data: { id: number } | null | undefined;
  timedOut: boolean;
};

export type ClarityOneSessionPresentation =
  | { kind: "loading" }
  | { kind: "ready" }
  | { kind: "unauthenticated" }
  | { kind: "recovery"; reason: "error" | "timeout" };

/**
 * Previous loop: `!isLoading && !me` treated errors and stalled fetches as
 * unauthenticated, bouncing /home ↔ /login while the cookie was valid.
 */
export function presentClarityOneSession(state: ClarityOneMeQueryState): ClarityOneSessionPresentation {
  if (state.data) return { kind: "ready" };
  if (state.timedOut) return { kind: "recovery", reason: "timeout" };
  if (state.isError) return { kind: "recovery", reason: "error" };
  if (state.isLoading || state.isFetching || !state.isSuccess) return { kind: "loading" };
  return { kind: "unauthenticated" };
}

export function loginShouldRedirectHome(state: Pick<ClarityOneMeQueryState, "isSuccess" | "data">): boolean {
  return Boolean(state.isSuccess && state.data);
}

export function rootRedirectPath(state: ClarityOneMeQueryState): "/login" | "/home" | null {
  const presented = presentClarityOneSession(state);
  if (presented.kind === "ready") return "/home";
  if (presented.kind === "unauthenticated") return "/login";
  return null;
}

export function unauthenticatedLoginPath(): string {
  return clarityOneLoginUrlWithRedirect("/home");
}

export function staffCustomerCardReturnUrl(referrer: string | undefined | null): string | null {
  if (!referrer) return null;
  try {
    const url = new URL(referrer);
    if (url.hostname !== "portal.claritygroup.com.sg") return null;
    if (!url.pathname.includes("/customers/")) return null;
    return referrer;
  } catch {
    return null;
  }
}
